import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { clientState } from "recoils/clientState"
import { companyState } from "recoils/companyState"
import { isInitializingState } from "recoils/initializingState"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
  isRecruitNotFoundState,
} from "recoils/isNotFoundState"
import { recruitsState } from "recoils/recruitsState"
import {
  getAllRecruitDetails,
  getClientProfile,
  getCompanyDetail,
} from "usecases/firebase/functions"

export const useFetchClient = () => {
  const setClient = useSetRecoilState(clientState)

  return async () =>
    await getClientProfile()
      .then((profileData) => {
        profileData && setClient(profileData)
      })
      .catch((e) => console.log(e))
}

export const useFetchCompany = () => {
  const setCompany = useSetRecoilState(companyState)

  return async () =>
    await getCompanyDetail()
      .then((companyData) => {
        companyData && setCompany(companyData)
      })
      .catch((e) => {
        console.log(e)
      })
}

export const useFetchRecruits = () => {
  const setRecruits = useSetRecoilState(recruitsState)

  return async () =>
    await getAllRecruitDetails()
      .then((recruitData) => {
        recruitData.data && setRecruits(recruitData.data)
      })
      .catch((e) => {
        console.log(e)
      })
}
export const useInitializeAccountData = () => {
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const isRecruitNotFound = useRecoilValue(isRecruitNotFoundState)
  const [isInitializing, setIsInitializing] =
    useRecoilState(isInitializingState)

  const fetchClient = useFetchClient()
  const fetchCompany = useFetchCompany()
  const fetchRecruits = useFetchRecruits()

  const initializeClient = async () => {
    if (isClientNotFound) {
      return await fetchClient()
    }
  }

  const initializeCompany = async () => {
    if (isCompanyNotFound) {
      return await fetchCompany()
    }
  }

  const initializeRecruits = async () => {
    if (isRecruitNotFound) {
      return await fetchRecruits()
    }
  }

  return async () => {
    if (isInitializing) {
      return
    }
    setIsInitializing(true)

    await Promise.all([
      initializeClient(),
      initializeCompany(),
      initializeRecruits(),
    ]).finally(() => {
      setIsInitializing(false)
    })
  }
}
